const es = {
  navbar: {
    drawer: {
      home: 'Dashboard',
      template: 'Plantillas',
      workflow: 'Workflow Manager',
      inventory: 'Inventario',
      dataModel: 'Modelos de datos',
      documentation: 'Documentacion',
      credential: 'Credenciales',
      project: 'Proyectos',
      user: 'Usuarios',
      company: 'Companias',
      configuration: 'Configuracion',
      macro: 'Macro',
      job: 'Jobs',
      roles: 'Roles',
      apiReference: 'API Reference',
      niko: 'Niko'
    },
    profile: {
      changePassword: 'Cambio de contraseña',
      logout: 'Cerrar sesion'
    }
  },
  login: {
    headline: 'Iniciar Sesion',
    components: {
      submit: 'Login'
    },
    form: {
      username: {
        label: 'Nombre de Usuario',
        placeholder: 'Ingrese un nombre de usuario'
      },
      password: {
        label: 'Contraseña',
        placeholder: 'Ingrese una contraseña'
      },
      rememberMe: {
        label: 'Recuerdame'
      }
    },
    alert: {
      success: 'Ingreso exitoso',
      error: 'Problemas al intentar iniciar sesión',
      blocked: 'User blocked'
    }
  },
  home: {
    titleTab: 'Entropy',
    labelTopbar: 'Dashboard',
    headline: 'Overview',
    components: {
      kpis: {
        projects: 'Proyectos ejecutados',
        nodes: 'Nodos configurados',
        errors: 'Errores con los nodos',
        inventories: 'Inventarios',
        services: 'Modelos de servicios'
      },
      chartLine: {
        title: 'Historia laboral',
        firstLabel: 'Exitoso',
        secondLabel: 'Fallido'
      },
      pieChart: {
        title: 'Estadisticas',
        subtitle: 'Trabajos corridos'
      },
      notResults: 'Sin resultados encontrados'
    },
    notCorrectDateRango: 'Por favor seleccione una fecha correcta'
  },
  templateList: {
    titleTab: 'Plantillas de trabajo',
    labelTopbar: 'Plantillas',
    headline: 'Plantillas de trabajo',
    components: {
      titleList: 'Resumen de plantillas',
      add: 'Nueva plantilla',
      table: {
        delete: 'Borrar esta plantilla',
        edit: 'Editar esta plantilla',
        run: 'Ejecutar esta plantilla'
      },
      alert: {
        success: 'Plantilla creada exitosamente',
        putSuccess: 'Plantilla actualizada exitosamente',
        deleteSuccess: 'Plantilla eliminada exitosamente',
        error: 'Algo salió mal',
        errorJob: 'Error intentando Ejecutar la plantilla',
        errorJobInventory: 'No se puede ejecutar la plantilla porque el inventario está en uso'
      },
    },
    stepper: {
      backButton: 'Atras',
      nextButton: 'Siguiente',
      completedButton: 'Crear',
      about: {
        label: 'Detalle',
        title: 'Cofiguracion inicial',
        secondTitle: 'Opciones',
      },
      etiqueta: {
        label: 'Etiqueta',
        title: 'Configuracion de etiquetas',
      },
      notification: {
        label: 'Notificaciones',
        title: 'Agregar notificaciones',
        buttonLabel: 'Agregar',
        table: {
          title: 'Sin notificaciones agregadas',
          description: 'Seleccione un usario y un tipo para agregar',
          actionDelete: 'Removerr esta notificaciones',
        },
      },
      encuesta: {
        label: 'Encuesta', // votacion
        title: 'Agregar encuesta',
        buttonLabel: 'Agregar',
        modal: {
          description: 'Tipo de encuesta seleccionada: {{ type }}',
          buttonCerrar: 'Cerrar',
          rangeSubtitle: 'Rango',
          multipleSubtitle: 'Opciones',
          edit: {
            title: 'Editar encuesta',
            button: 'Guardar',
          },
          create: {
            title: 'Cracion completada',
            button: 'Crear',
          },
        },
        table: {
          title: 'No hay encuesta agregadas',
          description: 'Seleccione un tipo de encuesta para agregar',
          actionDelete: 'Remover esta encuesta',
          actionEdit: 'Editar esta encuesta',
        },
      },
    },
    form: {
      name: {
        label: 'Nombre',
        placeholder: 'Ingresar nombre de plantilla',
      },
      description: {
        label: 'Descripción',
        placeholder: 'Ingresar unar descripción',
      },
      jobType: {
        label: 'Tipo de trabajo',
        helperText: 'Seleccione una forma de ejecutar el trabajo',
      },
      proyecto: {
        label: 'Proyecto',
        helperText: 'Seleccionar el proyecto a usar',
      },
      inventario: {
        label: 'Inventario',
        helperText: 'Seleccionar el inventario a usar',
      },
      playbook: {
        label: 'Playbook',
        helperText: 'Seleccionar el playbook a usar',
      },
      credencial: {
        label: 'Credencial',
        helperText: 'Seleccionar la credencial a usar',
      },
      forks: {
        label: 'Bifurcación', // fork
        helperText:
          'Número máximo de procesos simultáneos y paralelos para usar en la ejecución del playbook',
      },
      limit: {
        label: 'Limite',
        placeholder: 'Ingresar limite',
        helperText:
          'El número máximo de anfitriones para ejecutar en el playbook, dentro de un grupo',
      },
      levelDetail: {
        label: 'Nivel de detalle',
        helperText: 'Control detallado en la salida de ejecución de trabajos',
      },
      tagsJob: {
        label: 'Etiquetas de trabajo',
        placeholder: 'Ingresar una etiqueta de trabajo',
        helperText:
          'Especificación de qué tareas, pertenecientes al playbook, se van a ejecutar',
      },
      tagsSkip: {
        label: 'Saltear etiquetas',
        placeholder: 'Ingresar una etiqueta para saltear',
        helperText:
          'Especificación de qué tareas, pertenecientes al playbook, no se van a ejecutar',
      },
      etiquetas: {
        label: 'Etiquetas',
        placeholder: 'Ingresar una nueva etiqueta',
        helperText:
          'Etiquetas de trabajo, esto nos permite poder describir y reconocer dentro de un proyecto',
      },
      timeout: {
        label: 'Tiempo muerto', // Timeout
        helperText:
          'Tiempo máximo (en segundos) que debe ejecutarse el playbook, de lo contrario, se cancelará. Por defecto el valor es 0',
      },
      commandLine: {
        label: 'Linea de comando',
        placeholder: 'Ingrese una linea de comando',
      },
      showChanges: {
        label: 'Mostrar cambios',
        helperText:
          'Permite la visualización, en la salida, de los cambios realizados por el playbook',
      },
      consultExecution: {
        label: 'Consultar Ejecucion',
        helperText:
          'Habilita la consulta de ejecución en el momento de ejecutar el playbook',
      },
      enabledPrivileges: {
        label: 'Habilitar elevacion de priviligio',
        helperText:
          "Si está habilitado, ejecute el playbook como administrador. Equivalente a usar el '-- become'",
      },
      enabledJobs: {
        label: 'Habilitar trabajos simultáneos',
        helperText:
          'Habilitar la ejecución de tareas en paralelo en caso de que no sean dependientes',
      },
      useCache: {
        label: 'Usar cache de evonto',
        helperText: "Habilitar el plugin 'fact cache'",
      },
      variables: {
        label: 'Agregar variables',
        subtitle: '{{count}} lineas | {{lenguaje}} archivo',
        helperText:
          "Son 'extra vars' que el playbook usará al ejecutarse. Formato JSON.",
      },
      userProject: {
        label: 'Usuario',
        helperText: 'Usuarios de un proyecto',
      },
      notificationType: {
        label: 'Tipo',
      },
      encuestaVariable: {
        label: 'Variable',
        placeholder: 'Ingresar una variable de nombre',
      },
      encuestaType: {
        label: 'Tipo',
      },
      encuestaDescription: {
        label: 'Descripción',
        placeholder: 'Ingresar una descripción',
      },
      encuestaNumberFrom: {
        label: 'Desde',
        placeholder: 'Rango de un número',
      },
      encuestaNumberTo: {
        label: 'Hasta',
        placeholder: 'Rango de un número',
      },
      encuestaOptionValue: {
        label: 'Valor',
        placeholder: 'Ingresar un valor',
      },
      encuestaOptionDescription: {
        label: 'Descripción',
        placeholder: 'Ingresar una descripción',
      },
    },
  },
  templateCreate: {
    titleTab: 'Crear plantilla',
    labelTopbar: 'Plantillas > Crear plantilla',
    headline: 'Nueva Plantilla',
    components: {
      submit: 'Crear nueva plantilla',
      alert: {
        success: 'Plantilla creada exitosamente',
        error: 'Algo salió mal',
      },
    },
  },
  templateEdit: {
    titleTab: 'Editar plantilla',
    labelTopbar: 'Plantillas > Editar workflow',
    headline: 'Actualizar plantilla',
    components: {
      submit: 'Guardar cambios'
    },
  },
  workflowList: {
    titleTab: 'Workflow Manager',
    labelTopbar: 'Workflows',
    headline: 'Workflows',
    components: {
      titleList: 'Resumen de Workflows',
      add: 'Workflow Nuevo',
      table: {
        delete: 'Borrar este workflow',
        edit: 'Editar este workflow',
        run: 'Ejecutar este workflow'
      },
      alert: {
        success: 'Workflow creado exitosamente',
        putSuccess: 'Workflow actualizado exitosamente',
        deleteSuccess: 'Workflow borrado',
        error: 'Algo salió mal',
        errorJob: 'Error al Ejecutar el workflow'
      },
    },
    stepper: {
      backButton: 'Atras',
      nextButton: 'Siguiente',
      completedButton: 'Crear',
      about: {
        label: 'Detalle',
        title: 'Detalles',
      },
      notification: {
        label: 'Notificaciones',
        title: 'Agregar notificaciones',
        buttonLabel: 'Agregar',
        table: {
          title: 'Sin notificaciones agregadas',
          description: 'Seleccionar un usuario y un tipo para agregar',
          actionDelete: 'Remover esta notificacion',
        },
      },
      workflow: {
        title: 'Definicion de Workflow',
        buttonLabel: 'Editar tareas',
      },
    },
    form: {
      name: {
        label: 'Nombre',
        placeholder: 'Ingresar nombre de workflow',
      },
      description: {
        label: 'Descripción',
        placeholder: 'Ingresar una descripción',
      },
      proyecto: {
        label: 'Proyecto',
        helperText: 'Seleccionar un proyecto a usar',
      },
      userProject: {
        label: 'Usuario',
        helperText: 'Usuarios de un proyecto',
      },
      notificationType: {
        label: 'Tipo',
      },
    },
  },
  workflowCreate: {
    titleTab: 'Crear workflow',
    labelTopbar: 'Workflows > Crear workflow',
    headline: 'Workflow nuevo',
    components: {
      submit: 'Crar un workflow nuevo'
    },
  },
  workflowEdit: {
    titleTab: 'Editar workflow',
    labelTopbar: 'Workflows > Editar workflow',
    headline: 'Actualizar workflow',
    headlineView: 'workflow',
    components: {
      submit: 'Guardar cambios',
      task: {
        linkModeMessage: "¡Estás en modo enlace!",
        headline: 'Define tareas',
        legend: 'Leyenda',
        counter: '{{tasks}} tareas',
        notResults: 'Sin tareas definidas',
        editLabel: 'Tarea',
        addLabel: 'Agrega tarea',
        linkLabel: 'Enlazar',
        connectionLabel: 'Coneccion',
        form: {
          save: 'Guardar',
          cancel: 'Cancelar',
          delete: 'Borrar',
          newTab: "Abrir",
          confirm: "Confirmar cambios",
          condition: "Agregar condicion",
          add: {
            tipo: 'Workflow',
            action: 'Accion',
            endEvent: 'Finalizar evento',
            satisfy: {
              label: "¿Satisfará?",
              optionAll: "Todas las condiciones",
              optionSome: "Algunas condiciones"
            }
          },
          connection: {
            field: {
              label: 'Campo',
              placeholder: 'Ingresar campo'
            },
            condition: 'Condicion',
            dataType: 'Tipo de datos',
            result: {
              label: 'Resultado del valor',
              placeholder: 'Ingresar valor'
            },
            conditionSelected: '{{number}} Condicion'
          },
          edit: {
            workflow: "Workflow",
            template: "Plantilla"
          }
        }
      }
    },
  },
  inventoryList: {
    titleTab: 'Inventarios',
    labelTopbar: 'Inventarios',
    headline: 'Inventarios',
    hosts: {
      title: 'Anfitriones',
      button: 'Agregar',
      create: {
        title: 'Crear anfitrión',
      },
      edit: {
        title: 'Editar anfitrión',
      },
      table: {
        title: 'Sin anfitriones agregado',
        description: 'Agregar un nuevo anfitrión',
        actionDelete: 'Remover este host',
        columns: {
          name: 'nombre',
          ip: 'ip'
        },
        actions: {
          edit: 'Editar',
          delete: 'Borrar'
        }
      },
      error: {
        hostFound: 'Este anfitrión fue ingresado',
        hostDelete: 'Un grupo usa este anfitrión'
      },
    },
    groupHosts: {
      title: 'Agrupar anfitriones',
      button: 'Agregar',
      create: {
        title: 'Crear grupo',
      },
      edit: {
        title: 'Editar grupo',
      },
      table: {
        title: 'Sin grupos agregados',
        description: 'Agregar grupo nuevo',
        actionDelete: 'Remover este grupo',
        columns: {
          name: 'nombre',
          hosts: 'anfitrión'
        },
        actions: {
          edit: 'Editar',
          delete: 'Borrar'
        }
      },
      error: {
        groupHostFound: 'Este grupo fue ingresado',
        groupDelete: 'Niños usan este grupo'
      },
    },
    childrenGroupHost: {
      title: 'Grupo de niños',
      button: 'Agregar',
      create: {
        title: 'Crear grupo de niños',
      },
      edit: {
        title: 'Editar grupo de niños',
      },
      table: {
        title: 'Sin grupos de niños agregado',
        description: 'add a new grupo de niños',
        actionDelete: 'Remover este grupo de niños',
        columns: {
          name: 'nombre',
          groups: 'grupos'
        },
        actions: {
          edit: 'Editar',
          delete: 'Borrar'
        }
      },
      error: {
        childrenGroupHostFound: 'Este grupo de niños fue ingresado'
      },
    },
    components: {
      titleList: 'Resumen de inventarios',
      add: 'Inventario nuevo',
      table: {
        delete: 'Borrar este inventario',
        edit: 'Editar este inventario',
      },
      alert: {
        success: 'Inventario creado exitosamente',
        putSuccess: 'Inventario actualizado exitosamente',
        deleteSuccess: 'Inventario borrado',
        error: 'Algo salió mal',
      },
    },
    form: {
      title: 'Detalles',
      titleHost: 'Configuracion del anfitrión',
      name: {
        label: 'Nombre',
        placeholder: 'Ingresar nombre del inventario',
      },
      description: {
        label: 'Descripción',
        placeholder: 'Ingresar una descripción de inventario'
      },
      company: {
        label: 'Compañías',
        helperText: 'Seleccione la compañía',
      },
      inventoryType: {
        label: 'Tipo',
        helperText: 'Seleccione el tipo',
      },
      tags: {
        label: 'Etiquetas',
        placeholder: 'Ingresar una etiqueta nueva'
      },
      modalHostName: {
        label: 'Nombre del anfitrión',
        placeholder: 'Ingresar el nombre del anfitrión'
      },
      modalGroupName: {
        label: 'Nombre del grupo',
        placeholder: 'Ingresar el nombre'
      },
      modalIpAddress: {
        label: 'Direccion Ip',
        placeholder: 'Ingreso de direccion ip'
      },
      modalNetworkType: {
        label: 'Tipo de Red',
        placeholder: 'Ingresar el tipo de red'
      },
      modalIsActive: {
        label: 'Activo', // Active
      },
      modalTags: {
        label: 'Etiquetas',
        placeholder: 'Ingresar una etiqueta',
      },
      variables: {
        label: 'Additional variables',
        subtitle: '{{count}} lineas | {{language}} archivo',
        helperText: "",
      },
      modalVariables: {
        label: 'Additional variables',
        subtitle: '{{count}} lineas | {{language}} archivo',
        helperText: "",
      },
      modalGroupDescription: {
        label: 'Descripción del grupo',
        placeholder: 'Ingresar la descripción'
      },
      modalGroupHosts: {
        label: 'Anfitrión',
      },
      modalChildrenGroupName: {
        label: 'Nombre',
        placeholder: 'Ingresar el nombre'

      },
      modalChildrenGroupDescription: {
        label: 'Descripción',
        placeholder: 'Ingresar la descripción'
      },
      modalChildrenGroupHosts: {
        label: 'Grupos'
      },
      //TODO: DELETE THIS PLEASE >:l
      proyecto: {
       label: 'Proyecto',
       helperText: 'Seleccione the proyecto a usar',
     },
    },
  },
  inventoryCreate: {
    titleTab: 'Crear Inventario',
    labelTopbar: 'Inventarios > Crear inventario',
    headline: 'Inventario nuevo',
    components: {
      submit: 'Crear inventario nuevo'
    },
  },
  inventoryEdit: {
    titleTab: 'Editar Inventario',
    labelTopbar: 'Inventarios > Editar inventario',
    headline: 'Editar Inventario',
    components: {
      submit: 'Editar Inventario'
    },
  },
  dataModelList: {
    titleTab: 'Modelos de datos',
    labelTopbar: 'Modelos de datos',
    headline: 'Modelos de datos',
    components: {
      titleList: 'Modelos de datos summary',
      add: 'Nuevo modelo de datos',
      table: {
        delete: 'Borrar este modelo de datos',
        edit: 'Editar este modelo de datos',
      },
      alert: {
        success: 'Modelo de datos crear exitosamente',
        putSuccess: 'Modelo de datos actualizar exitosamente',
        deleteSuccess: 'Modelo de datos borrado',
        error: 'Algo salió mal',
      },
    },
    form: {
      title: 'Detalle',
      name: {
        label: 'Nombre',
        placeholder: 'Ingresar nombre del modelo',
      },
      proyecto: {
        label: 'Proyecto',
        helperText: 'Seleccionar el proyecto a usar',
      },
      variables: {
        label: 'Variables adicionales',
        subtitle: '{{count}} lineas | {{language}} archivo',
        helperText: "Servicio de modelo de datos",
      },
    },
  },
  dataModelCreate: {
    titleTab: 'Crear modelo de datos',
    labelTopbar: 'Modelos de datos > Crear modelo de datos',
    headline: 'Nuevo modelo de datos',
    components: {
      submit: 'Crear nuevo modelo de datos'
    },
  },
  dataModelEdit: {
    titleTab: 'Editar modelo de datos',
    labelTopbar: 'Inventarios > Editar modelo de datos',
    headline: 'Editar modelo de datos',
    components: {
      submit: 'Actualizar modelo de datos'
    },
  },
  dataModelView: {
    titleTab: 'Ver modelo de datos',
    labelTopbar: 'Inventarios > Ver modelo de datos',
    headline: 'Ver modelo de datos',
  },
  documentationList: {
    titleTab: 'Documentacion',
    labelTopbar: 'Documentacion',
    headline: 'Documentacion',
    components: {
      titleList: 'Resumen de ocumentacion',
      table: {
        view: 'Ver este documento',
      },
    },
    form: {
      title: 'Detalles',
      name: {
        label: 'Nombre del documento'
      },
      document: {
        label: 'Archivo',
        subtitle: '{{count}} lineas | archivo JSON',
      },
    },
  },
  documentView: {
    titleTab: 'Ver documento',
    labelTopbar: 'Documentacion > Ver documento',
    headline: 'Ver documento',
  },
  credentialList: {
    titleTab: 'Credenciales',
    labelTopbar: 'Credenciales',
    headline: 'Credenciales',
    components: {
      titleList: 'Resumen deredenciales',
      add: 'Credencial nueva',
      table: {
        delete: 'Borrar esta credencial',
        edit: 'Editar esta credencial',
      },
      alert: {
        success: 'Credencial creada exitosamente',
        putSuccess: 'Credencial actualizada exitosamente',
        deleteSuccess: 'Credencial borrada',
        error: 'Algo salió mal',
      },
      types: {
        network: 'Red',
        machine: 'Maquina',
        token: 'Token',
        pem: 'Pem'
      }
    },
    form: {
      title: 'Credencial',
      subtitle: 'Detalle',
      name: {
        label: 'Nombre',
        placeholder: 'Ingresar nombre de la credencial',
      },
      description: {
        label: 'Descripción',
        placeholder: 'Ingresar descripción de la credencial',
      },
      company: {
        label: 'compañia',
        helperText: 'compañia que usara las credenciales',
      },
      tipo: {
        label: 'Tipo', 
      },
      etiquetas: {
        label: 'Etiquetas',
        helperText:  'etiquetas a usar en credencial',
        placeholder: 'etiquetas a usar en credencial',
      },
      usuario: {
        label: 'usuario',
      },
      contraseña: {
        label: 'contraseña',
      },
      enabled: {
        label: 'habilitada',
      },
      privateKey: {
        label: 'llave privada',
      },
      token: {
        label: 'token',
      },
      sudo: {
        label: 'sudo',
      },
    },
  },
  credentialCreate: {
    titleTab: 'Crear credencial',
    labelTopbar: 'Credenciales > Crear credencial',
    headline: 'Credencial nueva',
    components: {
      submit: 'Crear credencial nueva'
    },
  },
  credentialEdit: {
    titleTab: 'Editar Credencial',
    labelTopbar: 'Credenciales > Editar credencial',
    headline: 'Editar Credencial',
    components: {
      submit: 'Editar Credencial'
    },
  },
  projectList: {
    titleTab: 'Proyectos',
    labelTopbar: 'Proyectos',
    headline: 'Proyectos',
    components: {
      titleList: 'Resumen de proyectos',
      add: 'Proyecto nuevo',
      table: {
        delete: 'Borrar este proyecto',
        edit: 'Editar este proyecto',
        sync: 'Sincronizar proyecto',
      },
      alert: {
        success: 'Proyecto creado exitosamente',
        putSuccess: 'Proyecto actualizado exitosamente',
        deleteSuccess: 'Proyecto borrado',
        syncSuccess: 'Sincronización iniciada',
        error: 'Algo salió mal',
      },
    },
    form: {
      title: 'Detalle',
      name: {
        label: 'Nombre',
        placeholder: 'Ingresar nombre del proyecto',
      },
      description: {
        label: 'Descripción',
        placeholder: 'Ingresar proyecto descripción',
      },
      company: {
        label: 'Compañia',
        placeholder: 'Seleccione un proyecto',
      },
      scmType: {
        label: 'Tipo de SCM',
        placeholder: 'Ingresar tipo de SCM',
      },
      folder: {
        label: 'Nombre de la carpeta que tiene el proyecto',
        placeholder: 'Ingresar el nombre de la carpeta',
      },
      scmUrl: {
        label: 'URL del SCM',
        placeholder: 'https://github.com/org/repo.git',
      },
      scmBranch: {
        label: 'Rama del SCM',
        placeholder: 'HEAD',
      },
      scmRefspec: {
        label: 'Refspec del SCM',
        placeholder: '+refs/heads/*:refs/remotes/origin/*',
      },
      credential: {
        label: 'Credencial del SCM',
      },
      clean: {
        label: 'Limpiar',
      },
      deleteOnUpdate: {
        label: 'Borrar al actualizar',
      },
      allowBranchOverride: {
        label: 'Permitir anular rama',
      }
    },
  },
  projectCreate: {
    titleTab: 'Crear proyecto',
    labelTopbar: 'Proyectos > Crear proyecto',
    headline: 'Proyecto nuevo',
    components: {
      submit: 'Crear proyecto nuevo'
    },
  },
  projectEdit: {
    titleTab: 'Editar Proyecto',
    labelTopbar: 'Proyectos > Editar proyecto',
    headline: 'Editar proyecto',
    components: {
      submit: 'Editar Proyecto'
    },
  },
  userList: {
    titleTab: 'Usuarios',
    labelTopbar: 'Usuarios',
    headline: 'Lista de suario',
    components: {
      titleList: 'Resumen de Usuario',
      add: 'Usuario nuevo',
      addRole: 'Agregar rol',
      table: {
        delete: 'Borrar este usuario',
        edit: 'Editar este usuario',
      },
      alert: {
        success: 'Usuario creado exitosamente',
        putSuccess: 'Usuario actualizado exitosamente',
        deleteSuccess: 'Usuario borrado',
        error: 'Algo salió mal',
      },
    },
    form: {
      title: 'Detalle',
      subtitle: 'Roles',
      firstname: {
        label: 'Nombre',
        placeholder: 'Ingresar nombre del usuario',
      },
      surname: {
        label: 'Apellido',
        placeholder: 'Ingresar apellido del usuario',
      },
      username: {
        label: 'Nombre del usuario',
        placeholder: 'Ingrese el nombre del usuario',
      },
      email: {
        label: 'Email',
        placeholder: 'Ingrese el mail usuario',
      },
      active: {
        label: 'activo',
      },
      selectAll: {
        label: 'Seleccionar todos',
      },
      admin: {
        label: 'Administrador',
      },
      contraseña: {
        label: 'Contraseña',
        placeholder: 'Ingrese la contraseña del usuario',
      },
      confirmPassword: {
        label: 'Confirmar Contraseña',
        placeholder: 'Confirmar Contraseña',
      },
      rol: {
        label: 'Rol',
        placeholder: 'seleccione un rol',
      },
      error: {
        rol: 'Elemento ya agregado',
        equalPassword: 'La contraseña no es igual',
      }
    },
  },
  companyList: {
    titleTab: 'Companies',
    labelTopbar: 'Companies',
    headline: 'Companies',
    components: {
      titleList: 'Companies summary',
      add: 'New Compañia',
      table: {
        delete: 'Delete this company',
        edit: 'Editar this company',
      },
      alert: {
        success: 'Compañia created exitosamente',
        putSuccess: 'Compañia actualizada exitosamente',
        deleteSuccess: 'Compañia deleted',
        error: 'Algo salió mal',
      },
    },
    form: {
      title: 'Detalle',
      name: {
        label: 'Name',
        placeholder: 'Enter company name',
      },
      description: {
        label: 'Descripción',
        placeholder: 'Enter company descripción',
      },
    },
  },
  companyCreate: {
    titleTab: 'Crear Compañia',
    labelTopbar: 'Compañias > Crear compañia',
    headline: 'Compañia nueva',
    components: {
      submit: 'Crear compañia nueva'
    },
  },
  companyEdit: {
    titleTab: 'Editar Compañia',
    labelTopbar: 'Compañias > Editar compañia',
    headline: 'Editar Compañia',
    components: {
      submit: 'Editar Compañia'
    },
  },
  configuration: {
    titleTab: 'Configuraciones',
    labelTopbar: 'Configuraciones',
    headline: 'Configuraciones',
    components: {
      alert: {
        putSuccess: 'Configuración actualizada exitosamente',
        error: 'Algo salió mal',
      },
    },
    form: {
      title: 'Detalle',
      vault: {
        label: 'Ruta de la bóveda',
        placeholder: 'Ruta de la bóveda',
      },
      nepalRunner: {
        label: 'Corredor de Entropy',
        placeholder: 'Corredor de Entropy',
      },
      nepalRunnerHttpUrl: {
        label: 'Http URL de corredor de Entropy',
        placeholder: 'Http URL corredor de Entropy',
      },
      ansibleRunerPath: {
        label: 'Ruta del corredor de Ansible',
        placeholder: 'Ruta del corredor de Ansible',
      },
      ansibleConfig: {
        label: 'Configuración de Ansible',
        placeholder: 'Ingrese la ruta de configuración de Ansible'
      },
      threads: {
        label: 'Hilos',
        placeholder: 'Ingrese hilos'
      },
      inventoryPath: {
        label: 'Ruta de Inventario',
        placeholder: 'Ingrese ruta de inventario'
      },
      macrosPlaybookPath: {
        label: 'Ruta del Playbook de Macros',
        placeholder: 'Ingrese ruta del playbook de macros'
      },
      macrosPlaybook: {
        label: 'Playbook de Macros',
        placeholder: 'Ingrese playbook de macros'
      },
      macrosConfigPath: {
        label: 'Ruta de Configuración de Macros',
        placeholder: 'Ingrese ruta de configuración de macros'
      },
      ansibleMongoUrl: {
        label: 'URL del Mongo de Ansible',
        placeholder: 'URL del Mongo de Ansible',
      },
      nepalBackendFileEndpoint: {
        label: 'Extremo del archivo back-end de Entropy',
        placeholder: 'Extremo del archivo back-end de Entropy',
      },
      rabitmq: {
        label: 'RabbitMQ',
        placeholder: 'RabbitMQ',
      },
      rabitmqTail: {
        label: 'Cola RabbitMQ',
        placeholder: 'Cola RabbitMQ',
      },
      mailHost: {
        label: 'Anfitrión de mail',
        placeholder: 'Anfitrión de Mail',
      },
      mailPort: {
        label: 'Puerto del mail',
        placeholder: 'Puerto del mail',
      },
      mailSecure: {
        label: 'Correo seguro',
        placeholder: 'Correo seguro',
      },
      mailUser: {
        label: 'Usuario del mail',
        placeholder: 'Usuario del mail',
      },
      mailPass: {
        label: 'Pase de correo',
        placeholder: 'Pase de correo',
      },
      mailRejectUnauthorized: {
        label: 'Rechazo de correo no autorizado',
        placeholder: 'Rechazo de correo no autorizado',
      },
      mailFrom: {
        label: 'Correo de',
        placeholder: 'Correo de',
      },
    },
  },
  configurationEdit: {
    titleTab: 'Editarf configuración',
    labelTopbar: 'Configuración > Editarf configuración',
    headline: 'Actualizar configuración',
    components: {
      submit: 'Guardar cambios'
    },
  },
  jobList: {
    titleTab: 'Jobs',
    labelTopbar: 'Jobs',
    headline: 'Jobs',
    components: {
      titleList: 'Resumen de Jobs',
      abort: 'Abortar todos los jobs',
      table: {
        stop: 'Abortar job corriendo',
        children: 'Ver todos los jobs',
        view: 'Ver este job',
        tags: {
          template: 'Plantilla',
          workflow: 'Workflow',
        },
        col: {
          type: 'Tipo'
        },
        delete: 'Eliminar este job',
        edit: 'Editar este job',
      },
      alert: {
        successAbort: 'Job abortado exitosamente',
        errorAbort: 'Problemas intentando abortar el job'
      },
    },
  },
  jobRunTemplate: {
    titleTab: 'Plantilla job',
    labelTopbar: 'Jobs > Plantilla job',
    headline: 'Plantilla job',
    components: {
      title: 'Detalle de {{job}}',
      label: {
        status: 'Estado',
        created: 'Creado',
        start: "Iniciado",
        finish: 'Finalizado',
        project: 'Proyecto',
        playbok: 'Playbook',
        credential: 'Credencial',
        environment: 'Entorno',
        logs: 'Archivo de configuración de registro'
      }
    },
  },
  jobRunWorkflow: {
    titleTab: 'Workflow job',
    labelTopbar: 'Jobs > Workflow job',
    headline: 'Workflow job',
    editHeadLine: 'Detalle del Workflow',
    components: {
      title: '{{job}}',
      subtitle: 'Detalle',
      label: {
        status: 'Estado',
        created: 'Creado',
        start: "Iniciado",
        finish: 'Finalizado',
        project: 'Proyecto',
        environment: 'Entorno'
      },
      button: {
        stopAll: 'Detener todo',
        view: 'Ver workflow'
      }
    },
  },
  changePassword: {
    titleTab: 'Cambiar Contraseña',
    labelTopbar: 'Cambiar Contraseña',
    headline: 'Cambiar Contraseña',
    components: {
      submit: 'Cambiar Contraseña'
    },
    form: {
      title: 'Cambiar Contraseña',
      oldPassword: 'Contraseña vieja',
      newPassword: 'Contraseña nueva',
      confirmPassword: 'Confirmar contraseña',
      error: {
        equalPassword: 'La contraseña no es igual'
      }
    },
    alert: {
      success: 'Contraseña editada exitosamente',
      error: 'Problemas intentando cambiar contraseña'
    },
  },
  roleList: {
    titleTab: 'Roles',
    labelTopbar: 'Roles',
    headline: 'Roles',
    components: {
      titleList: 'Resumen de Roles',
      add: 'Rol nuevo',
      submitPermissionProyect: 'Dar permisos al proyecto',
      table: {
        delete: 'Borrar este rol',
        edit: 'Editar este rol',
      },
      alert: {
        success: 'Rol creado exitosamente',
        putSuccess: 'Rol actualizado exitosamente',
        deleteSuccess: 'Rol eliminado',
        error: 'Algo salió mal',
      },
    },
    form: {
      title: 'Detalles',
      subtitle: 'Permisos de proyectos',
      subtitleGlobal: 'Permisos globales',
      name: {
        label: 'Nombre',
        placeholder: 'Ingrese el nombre del rol',
      },
      description: {
        label: 'Descripción',
        placeholder: 'Ingrese una descripción',
      },
      project: {
        label: 'Proyecto',
        helperText: 'Seleccione el proyecto al que otorgarle permisos',
      },
    }
  },
  roleCreate: {
    titleTab: 'Crear rol',
    labelTopbar: 'Roles > Crear rol',
    headline: 'Rol nuevo',
    components: {
      submit: 'Crear rol nuevo'
    },
  },
  roleEdit: {
    titleTab: 'Editar Rol',
    labelTopbar: 'Roles > Editar rol',
    headline: 'Editar Rol',
    components: {
      submit: 'Guardar Rol'
    },
  },
  userCreate: {
    titleTab: 'Crear usuario',
    labelTopbar: 'Users > Crear usuario',
    headline: 'Usuario nuevo',
    components: {
      submit: 'Crear usuario nuevo'
    },
  },
  userEdit: {
    titleTab: 'Editar usuario',
    labelTopbar: 'Users > Editar usuario',
    headline: 'Editar usuario',
    components: {
      submit: 'Guardar usuario'
    },
  },
  macroExecute: {
    labelTopbar: 'Macro',
    titleTab: 'Macro',
  },
  apiTokenList: {
    titleTab: 'API Reference',
    labelTopbar: 'API Reference',
    headline: 'API Reference',
    components: {
      tabs: {
        clients: 'Clientes',
        tokens: 'Tokens',
        audit: 'Auditoría',
        documentation: 'Documentación',
      },
      addClient: 'Nuevo cliente',
      addToken: 'Nuevo token',
      filterByClient: 'Filtrar por cliente',
      clientDialog: {
        title: 'Crear cliente de API',
      },
      tokenDialog: {
        title: 'Crear token de acceso',
        client: 'Cliente',
        scopes: 'Permisos (Scopes)',
        scopesHelp: 'Separados por coma, ej: jobs.run',
        allowedProjects: 'Proyectos permitidos',
        allowedTemplates: 'Plantillas permitidas',
        expiresDays: 'Expiración (días)',
        idsHelp: 'Separados por coma, ej: 1,2,3. Vacío = sin restricción',
        noRestriction: 'Sin restricción',
        loadingProjects: 'Cargando proyectos...',
        loadingTemplates: 'Cargando plantillas...',
        projectsHelp: 'Seleccionar proyectos. Vacío = todos los proyectos permitidos',
        templatesHelp: 'Plantillas disponibles según los proyectos seleccionados. Si no selecciona proyectos, no se mostrarán plantillas.',
        selectProjectFirst: 'Selecciona al menos un proyecto para ver las plantillas',
        noTemplatesForProjects: 'No hay plantillas disponibles para los proyectos seleccionados',
      },
      scopes: {
        jobs_run: 'Jobs: Ejecutar',
        jobs_read: 'Jobs: Leer',
        credentials_read: 'Credenciales: Leer',
        inventories_read: 'Inventarios: Leer',
        projects_read: 'Proyectos: Leer',
        templates_read: 'Plantillas: Leer',
      },
      plainTokenDialog: {
        title: 'Token generado',
        warning: 'Copia este token ahora. No se mostrará de nuevo.',
      },
      table: {
        clientsTitle: 'Clientes registrados',
        tokensTitle: 'Tokens de acceso',
        auditTitle: 'Log de auditoría',
        prefix: 'Prefijo',
        client: 'Cliente',
        scopes: 'Scopes',
        revoked: 'Revocado',
        active: 'Activo',
        expired: 'Expirado',
        expiresAt: 'Vence',
        lastUsed: 'Último uso',
        requestId: 'Request ID',
        method: 'Método',
        path: 'Ruta',
        status: 'Estado HTTP',
        ip: 'IP',
        duration: 'Duración',
      },
      actions: {
        toggle: 'Activar / Desactivar',
        deleteClient: 'Eliminar cliente',
        deleteToken: 'Eliminar token',
        revoke: 'Revocar token',
      },
      alert: {
        success: 'Operación exitosa',
        deleteSuccess: 'Eliminado exitosamente',
        revokeSuccess: 'Token revocado',
        error: 'Algo salió mal',
      },
      modal: {
        deleteClient: {
          title: '¿Eliminar cliente?',
          text: 'Esta acción eliminará el cliente y todos sus tokens. No se puede deshacer.',
        },
        revokeToken: {
          title: '¿Revocar token?',
          text: 'El token quedará inactivo de forma permanente.',
        },
        deleteToken: {
          title: '¿Eliminar token?',
          text: 'El token se ocultará del listado y no podrá volver a usarse. El historial de auditoría se conserva.',
        },
      },
    },
    docs: {
      title: 'API Externa Entropy',
      urlBase: 'URL base',
      urlBaseNote: 'Reemplazar host y puerto por los del entorno correspondiente.',
      commonHeaders: 'Headers comunes',
      statusCodes: 'Códigos de estado',
      endpointsLabel: 'Endpoints',
      th: {
        field: 'Campo',
        type: 'Tipo',
        required: 'Obligatorio',
        description: 'Descripción',
        yes: 'Sí',
        no: 'No',
      },
      statusChip: {
        ok: '200 OK',
        accepted: '202 Aceptado',
        unauthorized: '401 No autorizado',
        forbidden: '403 Sin permiso',
        notFound: '404 No encontrado',
        conflict: '409 Conflicto',
        unprocessable: '422 Payload inválido',
        rateLimit: '429 Rate limit',
      },
      scopeLabel: 'Scope: {{scope}}',
      section: {
        headersRequired: 'Headers obligatorios',
        body: 'Body',
        example: 'Ejemplo de petición',
        response200: 'Response 200',
        response202: 'Response 202',
        errors: 'Errores posibles',
        pathParams: 'Path parameters',
        queryParams: 'Query parameters (todos opcionales)',
        idempotencyTitle: 'Idempotencia',
      },
      idempotency: {
        intro: 'La clave Idempotency-Key es obligatoria en este endpoint. Su propósito es evitar jobs duplicados por reintentos del cliente.',
        rule1Prefix: 'Misma key + mismo body:',
        rule1Body: 'se devuelve la respuesta original sin crear un nuevo job. La response incluye el header X-Idempotency-Replayed: true.',
        rule2Prefix: 'Misma key + body distinto:',
        rule2Body: '409 idempotency_conflict.',
        rule3Prefix: 'Key nueva + mismo body:',
        rule3Body: 'se crea un job nuevo (operación independiente).',
        rule4: 'Si tu cliente reintenta automáticamente, debe reusar la misma key hasta confirmar la respuesta.',
      },
      commonHeadersData: {
        auth: { field: 'Authorization', type: 'string', required: 'Sí (excepto /health)', description: 'Bearer <api_token>. Token entregado al crear el cliente. No loguear ni versionar.' },
        contentType: { field: 'Content-Type', type: 'string', required: 'Sí (con body JSON)', description: 'application/json (en requests con body).' },
        idempotencyKey: { field: 'Idempotency-Key', type: 'UUID v4', required: 'Sí (solo POST /jobs)', description: 'Solo POST /jobs. Evita duplicados en reintentos.' },
        correlationId: { field: 'X-Correlation-Id', type: 'UUID', required: 'No', description: 'Opcional. Se persiste en el audit log.' },
      },
      endpoints: {
        health: {
          description: 'Liveness check. No requiere autenticación ni idempotency-key.',
        },
        createJob: {
          description: 'Crea y encola un job. El template debe pertenecer al proyecto enviado y estar en allowed_templates del token.',
          headersData: {
            auth: { field: 'Authorization', type: 'Bearer <api_token>', required: 'Sí', description: '' },
            contentType: { field: 'Content-Type', type: 'application/json', required: 'Sí', description: '' },
            idempotencyKey: { field: 'Idempotency-Key', type: 'UUID v4', required: 'Sí', description: 'Único por operación' },
          },
          bodyData: {
            worktemplate: { field: 'worktemplate_id', type: 'integer', required: 'Sí', description: 'ID del template. Debe estar en allowed_templates del token.' },
            project: { field: 'project_id', type: 'integer', required: 'Sí', description: 'ID del proyecto. Debe estar en allowed_projects del token.' },
            userInteraction: { field: 'userInteraction', type: 'object', required: 'No', description: 'Objeto libre. Ej: { "approval": "AUTO" }' },
            variables: { field: 'variables', type: 'object', required: 'No', description: 'Variables adicionales del job (extra_vars de Ansible). Objeto plano de valores escalares. Se combinan con las de la work template y, ante el mismo nombre, gana este valor. Ej: { "vlan": 100 }' },
          },
          errors: {
            '401': 'Token inválido, expirado o revocado.',
            '403': 'Scope faltante, project_not_allowed o template_not_allowed.',
            '404': 'worktemplate_not_found.',
            '409': 'idempotency conflict (misma key, body distinto).',
            '422': 'project_mismatch o payload inválido.',
          },
        },
        listJobs: {
          description: 'Lista jobs respetando los allowed_projects del token. Orden: created DESC NULLS LAST, job_id DESC.',
          queryParamsData: {
            ids: { field: 'ids', type: 'CSV int', required: 'No', description: 'Filtrar por job_id. Ej: ?ids=1,2,3' },
            status: { field: 'status', type: 'string', required: 'No', description: 'Status exacto: WA, RU, AB, FI' },
            proyectId: { field: 'proyect_id', type: 'integer', required: 'No', description: 'Filtrar por proyecto' },
            limit: { field: 'limit', type: 'int (1-500)', required: 'No', description: 'Default 100, truncado a 500' },
            offset: { field: 'offset', type: 'int (>=0)', required: 'No', description: 'Default 0' },
          },
          note: 'La respuesta no incluye campos pesados (ex_result, variables, ansible_out, hostresult). Para ver el detalle completo, usar GET /jobs/:jobId.',
          errors: {
            '401': 'Token inválido.',
            '403': 'Scope jobs.read faltante.',
            '422': 'Parámetros mal formados.',
          },
        },
        getJob: {
          description: 'Detalle completo de un job.',
          pathParamsData: {
            jobId: { field: 'jobId', type: 'integer', required: 'Sí', description: 'ID del job (positivo)' },
          },
          errors: {
            '401': 'Token inválido.',
            '403': 'Scope faltante, o job fuera de allowed_projects.',
            '404': 'Job no encontrado.',
            '422': 'jobId inválido.',
          },
        },
        getJobStatus: {
          description: 'Solo estado del job (subconjunto liviano, útil para polling).',
          pathParamsData: {
            jobId: { field: 'jobId', type: 'integer', required: 'Sí', description: 'ID del job (positivo)' },
          },
        },
        cancelJob: {
          description: 'Cancela un job en estado WA o RU. No requiere body.',
          pathParamsData: {
            jobId: { field: 'jobId', type: 'integer', required: 'Sí', description: 'ID del job (positivo)' },
          },
          errors: {
            '401': 'Token inválido.',
            '403': 'Scope faltante, o job fuera de allowed_projects.',
            '404': 'Job no encontrado.',
            '409': 'job_not_cancellable (el job ya finalizó o no está en estado cancelable).',
            '422': 'jobId inválido.',
          },
        },
      },
    },
  },
  macro: {
    titleTab: 'Ejecutar Macro',
    labelTopbar: 'Macro',
    headline: 'Macros',
    components: {
      alert: {
        postSuccess: 'Macro ejecutado exitosamente',
        error: 'Algo salió mal',
      },
      submit: 'ejecutar'
    },
    form: {
      title: 'Detalle',
      error: {
        inventory: 'El inventario es requerido',
        credential: 'La credencial es requerido'
      },
      name: {
        label: 'Nombre',
        placeholder: 'Ingresar el nombre de macro',
      },
      description: {
        label: 'Decripción',
        placeholder: 'Ingresar una decripción',
      },
      inventory: {
        label: 'Inventario',
        helperText: 'Seleccione un inventario a usar',
      },
      type: {
        label: 'Tipo',
        helperText: 'Seleccione un tipo',
      },
      hosts: {
        label: 'Anfitrión',
        placeholder: 'Ingrese Anfitrión',
        helperText: ''
      },
      credential: {
        label: 'Credencial',
        helperText: 'Seleccione una credencial a usar',
      },
      configFile: {
        label: 'Configuración del archivo',
        helperText: 'Seleccione una configuración del archivo a usar',
      },
    },
  },
  common: {
    status: {
      ok: 'Exito',
      er: 'Error',
      ab: 'Salteado',
      ne: 'Abortado',
      wa: 'Esperando',
      ru: 'Correiendo'
    },
    nodesOption: {
      succed: "Exitoso",
      error: "Error",
      always: "Siempre",
      condition: "Condición",
      noDependency: "Sin dependencia"
    },
    conditionsOption: {
      equalTo: "(==) igual a" ,
      notEqualTo: "(!=) no igual a",
      greaterThan: "(>) mayor que",
      greaterThanOrEqualTo: "(>=) mayor o igual a",
      lessThan: "(<) menor que",
      lessThanOrEqualTo: "(<=) menor o igual a"
    },
    dataSelect: {
      notificationType: {
        init: 'Inicio',
        endSuccess: 'Fin del exito',
        endError: 'Fin del error',
        autorize: 'Autorización',
      },
      pollingType: {
        text: 'Texto',
        number: 'Número',
        option: 'Multiples opciones',
      },
      pollingOption: {
        optionOne: 'Opción 1',
        optionTwo: 'Opción 2',
      },
      levelDetail: {
        normal: 'Normal',
        verbose: 'Verbose',
        moreVerbose: 'MoreVerbose',
        debug: 'Debug',
        connectionDebug: 'ConnectionDebug',
        connectionDebugplus: 'ConnectionDebugplus',
      },
      jobType: {
        eject: 'Ejecutar',
        check: 'Checkear',
        scan: 'Escanear',
      },
    },
    errors: {
      general: {
        title: 'Algo salió mal',
        subtitle: 'Encontramos un error al intentar conectarnos con nuestro servidor.',
        directory: 'El directorio no existe.'
      },
    },
    components: {
      macroSwichLabel: 'Macros',
      dateToLabel: 'Fecha hasta',
      dateFromLabel: 'Fecha desde',
      maximizeLabel: 'Maximizar editor',
      renderedView: 'Vista Renderizada',
      codeView: 'Vista de Código',
      importFile: 'Importar archivo',
      exportFile: 'Exportar archivo',
      cancelImportFile: 'Cancelar importar archivo',
      noDataLabel: 'Sin datos',
      noOptionsText: 'Sin opciones',
      footer: {
        title: 'Powered by',
        description: '© Octupus. Todos los derechos reservados.'
      },
      alert: {

      },
      dragzone: {
        invalidFormat: 'El archivo no tiene un formato valido',
        fileExtension: 'El archivo necesita una extensión'
      },
      table: {
        titleNotResults: 'Sin resultados encontrados.',
        descriptionNotResults: "No podemos encontrar ningún artículo que coincida con su búsqueda.",
        buttonNew: 'Crear uno nuevo',
        col: {
          username: 'Nombre de usuario',
          name: 'Nombre',
          description: 'Descripción',
          surname: 'Apellido',
          rate: 'Tasa Exitosa', // revisar 
          jobs: 'Ultimos jobs',
          view: 'Vista',
          action: 'Acciones',
          status: 'Estado',
          createdAt: 'Fecha de creación'
        }
      },
      chip: {
        edit: 'Editar',
        create: 'Crear',
        delete: 'Borrar',
        run: 'Ejecutar',
        visible: 'Visible',
      },
      search: {
        label: '¿Qué estás buscando?',
        placeholder: 'buscar',
      },
      project: {
        label: 'Proyectos',
      },
      buttons: {
        search: 'Buscar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        save: 'Guardar',
        returnHome: 'Volver al home',
        run: 'Ejecutar',
        view: 'Detalle de la vista',
        create: 'Crear',
        close: 'Cerrar'
      },
      chipList: {
        error: 'Elemento ya agregado',
      },
      modal: {
        label: '¿Te gustaria continuar?',
      },
      modalJob: {
        label: 'Ejecutar un job',
      }
    },
    rules: {
      empty: "Ninguna",
      required: 'Campo requerido',
      pattern: 'Entrada invalida',
      maxLength: 'Límite de caracteres máximos',
      minLength: 'Límite de caracteres mínimos',
      max: 'Límite de valor máximo',
      min: 'Límite de valor mínimo',
      placeholder: 'Ingresar el campo',
      email: 'Email invalido'
    },
    permissionLabels: {
      dasboard: 'Dasboard',
      templates: 'Plantillas',
      workflow: 'Workflow',
      inventories: 'Inventarios',
      dataModels: 'Modelos de datos',
      documentations: 'Documentaciones',
      credentials: 'Credencials',
      projects: 'Proyectos',
      users: 'Usuarios',
      companies: 'Compañias',
      configuration: 'Configuración',
      jobs: 'Jobs',
      roles: 'Roles',
      macros: 'Macros',
    },
    labels: {
      yes: 'SÍ',
      no: 'NO'
    },
    all: 'Todos',
    active: 'Activo',
    inactive: 'Inactivo',
    copy: 'Copiar',
    copied: '¡Copiado!',
    copyError: 'No se pudo copiar',
    copyFallback: 'Seleccionado · Ctrl+C',
    copyFallbackHint: 'El navegador bloqueó el copiado automático. Selecciona el token manualmente y cópialo con Ctrl+C (o Cmd+C en Mac).',
    required: 'Campo requerido'
  },
  template: {
    stepper: {
      polling: {
        modal:{
          create:{
            button: 'guardar'
          },
          edit: {
            button: 'Guardar'
          },
          buttonClose: 'cerrar'
        }
      }
    }
  },
};

export default es;
